import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Header from "components/Header/Header.js";
import styles from "assets/jss/material-kit-react/components/menuStyle.js";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "components/CustomButtons/Button.js";
import {
  useParams
} from "react-router-dom";
const useStyles = makeStyles(styles);

export default function Menu(props) {
  const classes = useStyles();
  let { id } = useParams();
  var active = 0
  if (id == "All")
    active = 0;
  else if (id == "Software")
    active = 1;
  else if (id == "Business")
    active = 2;
  else if (id == "Marketing")
    active = 7;
  else if (id == "Security")
    active = 3;
  else if (id == "Design")
    active = 4;
    else if (id == "OS")
    active = 5;
    else if (id == "Network")
    active = 6;
  else if (id == "ScienceCommittee")
    active = 8;
  else if (id == "DocumentInquiry")
    active = 9;
  else if (id == "TermsAndConditions")
    active = 10;
    else if (id == "Certificate")
    active = 11;
    else if (id == "Calander")
    active = 12;
  else
    active = 0;
  var showSubMenu = false;
  if (active >= 0 && active <= 7) {
    showSubMenu = true
  }

  return (
    <div >
      <div className={classes.topSection}><List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Button
            href="/Courses/Section/All"
            className={classes.navLink + " " + (showSubMenu==true ? classes.navLinkActive : "")}
            color="transparent">
            دوره‌های آموزشی
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href="/Courses/Section/ScienceCommittee/"
            className={classes.navLink + " " + (active == 8 ? classes.navLinkActive : "")}
            color="transparent">
            هیئت علمی
          </Button>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Button
            href="/Courses/Section/DocumentInquiry"
            className={classes.navLink + " " + (active == 9 ? classes.navLinkActive : "")}
            color="transparent">
            استعلام گواهینامه
          </Button>
        </ListItem>
        
        <ListItem className={classes.listItem + " " + classes.hidden}>
          <Button
            href="/Courses/Section/Certificate"
            className={classes.navLink + " " + (active == 11 ? classes.navLinkActive : "")}
            color="transparent">
          نمونه گواهینامه
          </Button>
        </ListItem>
        <ListItem className={classes.listItem + " " + classes.hidden}>
          <Button
            href="/Courses/Section/TermsAndConditions"
            className={classes.navLink + " " + (active == 10 ? classes.navLinkActive : "")}
            color="transparent">
            قوانین و مقررات
          </Button>
        </ListItem>
      </List></div>
      {showSubMenu&&(
      <div className={classes.section} >
        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <Button
              href="/Courses/Section/All"
              className={classes.subNavLink + " " + (active == 0 ? classes.subNavLinkActive : "")}
              color="transparent">
              همه دوره‌ها
            </Button>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Button
              href="/Courses/Section/Software"
              className={classes.subNavLink + " " + (active == 1 ? classes.subNavLinkActive : "")}
              color="transparent">
              برنامه نویسی و مهندسی نرم افزار
            </Button>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Button
              href='/Courses/Section/Business'
              className={classes.subNavLink + " " + (active == 2 ? classes.subNavLinkActive : "")}
              color="transparent">
              کسب‌و‌کار و مدیریت
            </Button>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Button
              href='/Courses/Section/Marketing'
              className={classes.subNavLink + " " + (active == 7 ? classes.subNavLinkActive : "")}
              color="transparent">
              بازاریابی
            </Button>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Button
              href='/Courses/Section/Security'
              className={classes.subNavLink + " " + (active == 3 ? classes.subNavLinkActive : "")}
              color="transparent">
              امنیت
            </Button>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Button
              href='/Courses/Section/OS'
              className={classes.subNavLink + " " + (active == 5 ? classes.subNavLinkActive : "")}
              color="transparent">
               سیستم عامل
            </Button>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Button
              href='/Courses/Section/Network'
              className={classes.subNavLink + " " + (active == 6 ? classes.subNavLinkActive : "")}
              color="transparent">
              شبکه
            </Button>
          </ListItem>
          <ListItem className={classes.listItem}>
            <Button
              href='/Courses/Section/Design'
              className={classes.subNavLink + " " + (active == 4 ? classes.subNavLinkActive : "")}
              color="transparent">
              طراحی و گرافیک
            </Button>
          </ListItem>
        </List>
      </div>
      )}
    </div>
  );
}
